import { SlidersHorizontal } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface Props {
  sort: string;
  onSortChange: (value: string) => void;
  /** Show the "Most relevant" option (only meaningful with a search term). */
  hasSearch?: boolean;
  resultCount?: number;
  activeFilterCount: number;
  onOpenFilters: () => void;
}

export default function CatalogToolbar({
  sort,
  onSortChange,
  hasSearch,
  resultCount,
  activeFilterCount,
  onOpenFilters,
}: Props) {
  return (
    <div className="flex items-center justify-between gap-3 border-b border-border pb-3">
      <div className="flex items-center gap-3">
        <button
          type="button"
          onClick={onOpenFilters}
          className="inline-flex items-center gap-2 rounded-md px-2 py-1.5 text-sm font-medium text-foreground hover:bg-muted lg:hidden"
        >
          Filter
          <SlidersHorizontal className="h-4 w-4" />
          {activeFilterCount > 0 && (
            <span className="inline-flex h-5 min-w-[20px] items-center justify-center rounded-full bg-primary px-1.5 text-[11px] font-bold text-primary-foreground">
              {activeFilterCount}
            </span>
          )}
        </button>
        {typeof resultCount === "number" && (
          <span className="hidden text-sm text-muted-foreground lg:inline">
            {resultCount.toLocaleString()} product{resultCount === 1 ? "" : "s"}
          </span>
        )}
      </div>

      <div className="flex items-center gap-2">
        <span className="hidden whitespace-nowrap text-sm text-muted-foreground sm:inline">
          Sort by
        </span>
        <Select value={sort} onValueChange={onSortChange}>
          <SelectTrigger className="h-9 w-[190px]">
            <SelectValue />
          </SelectTrigger>
          <SelectContent className="z-[300]">
            <SelectItem value="name_asc">Featured</SelectItem>
            {hasSearch && <SelectItem value="relevance">Most relevant</SelectItem>}
            <SelectItem value="alpha_asc">Alphabetically, A–Z</SelectItem>
            <SelectItem value="name_desc">Alphabetically, Z–A</SelectItem>
            <SelectItem value="price_asc">Price, low to high</SelectItem>
            <SelectItem value="price_desc">Price, high to low</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}